import { useState } from "react";
import { inp, todayWIB } from "../util";
import { Card, useLoad } from "./common";
import { CustomerSearch } from "./FollowupLog";
import { TaskStatus, TYPE_LABEL } from "./Tasks";

function Today({ date }) {
    const [c] = useLoad("/reporting/v2/ops/summary", { date });
    if (!c) return null;
    return (
        <div data-testid="fu-summary-today">
            <div className="grid grid-cols-[1fr_repeat(4,3.2rem)] gap-x-1 text-[10px] uppercase tracking-wider text-neutral-400 border-b border-mist pb-1"><span>Admin</span><span className="text-right">Hari ini</span><span className="text-right">Selesai</span><span className="text-right">Pending</span><span className="text-right">Terlambat</span></div>
            {c.rows.map((r) => (
                <div key={r.id} className="grid grid-cols-[1fr_repeat(4,3.2rem)] gap-x-1 text-sm py-1 border-b border-mist/60 tabular-nums" data-testid={`fu-summary-${r.id}`}>
                    <span className="truncate">{r.name}</span><span className="text-right">{r.count}</span><span className="text-right text-emerald-700">{r.completed}</span>
                    <span className="text-right text-sky-700">{r.pending}</span><span className={`text-right ${r.overdue ? "text-rose-700 font-semibold" : ""}`}>{r.overdue}</span>
                </div>
            ))}
            <p className="text-[11px] text-neutral-500 mt-2" data-testid="fu-team-sources">Sumber lead tim: {Object.entries(c.team_sources).map(([k, v]) => `${k} ${v}`).join(" · ")} · total {c.team_total}</p>
        </div>
    );
}

function Month({ month }) {
    const [c] = useLoad("/reporting/v2/ops/summary", { month });
    if (!c) return null;
    return (
        <div data-testid="fu-summary-month">
            {c.rows.map((r) => <div key={r.id} className="flex justify-between text-sm py-1 border-b border-mist/60"><span>{r.name}</span><span className="tabular-nums">{r.total} follow-up · {r.active_days} hari aktif</span></div>)}
        </div>
    );
}

export function ComplianceCard({ date }) {
    const [m, setM] = useState(false);
    const [meta] = useLoad("/reporting/v2/ops/meta");
    return (
        <Card title="Follow-up per Admin" testid="dash-fu-summary" right={<button type="button" className="text-xs underline" onClick={() => setM(!m)} data-testid="fu-summary-toggle">{m ? "Hari ini" : "Bulan ini"}</button>}>
            {m ? <Month month={date.slice(0, 7)} /> : <Today date={date} />}
            {meta && <div className="mt-3"><div className="text-[10px] uppercase tracking-widest text-neutral-400 mb-1">Riwayat customer</div><CustomerSearch meta={meta} /></div>}
        </Card>
    );
}

const VIEWS = { ALL: "Semua belum selesai", MENUNGGU_DITERIMA: "Menunggu Diterima", DALAM_PROSES: "Diterima / Dalam Proses", OVERDUE: "Terlambat" };

export function PendingBoard() {
    const [items] = useLoad("/reporting/v2/tasks", { scope: "all", d: todayWIB() });
    const [v, setV] = useState("ALL");
    const [pic, setPic] = useState("");
    const [type, setType] = useState("");
    if (!items) return null;
    const open = items.filter((t) => t.status === "PENDING");
    const pics = [...new Set(open.map((t) => t.assignee_name))].sort();
    const list = open.filter((t) => (v === "ALL" || (v === "OVERDUE" ? t.overdue : t.progress === v)) && (!pic || t.assignee_name === pic) && (!type || t.type === type));
    const n = (k) => open.filter((t) => (k === "OVERDUE" ? t.overdue : k === "ALL" || t.progress === k)).length;
    return (
        <Card title="Pending & Handover Tim" testid="pending-board">
            <div className="flex flex-wrap gap-1.5 mb-2">
                {Object.entries(VIEWS).map(([k, l]) => <button key={k} type="button" onClick={() => setV(k)} data-testid={`pending-view-${k}`} className={`px-2.5 py-1.5 text-xs rounded-sm border ${v === k ? "bg-ink text-white border-ink" : "bg-white border-mist"}`}>{l} ({n(k)})</button>)}
            </div>
            <div className="grid grid-cols-2 gap-2 mb-2">
                <select value={pic} onChange={(e) => setPic(e.target.value)} className={inp} data-testid="pending-filter-pic"><option value="">Semua PIC</option>{pics.map((p) => <option key={p}>{p}</option>)}</select>
                <select value={type} onChange={(e) => setType(e.target.value)} className={inp} data-testid="pending-filter-type"><option value="">Semua tipe</option>{Object.entries(TYPE_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
            </div>
            {list.length === 0 && <p className="text-xs text-neutral-400">Tidak ada tugas.</p>}
            {list.map((t) => (
                <div key={t.id} className="text-xs py-1.5 border-b border-mist/60 flex justify-between gap-2" data-testid={`pending-row-${t.id}`}>
                    <span><b>{t.customer}</b> — {t.task}<span className="text-neutral-500"> · {t.from_user_id !== t.assignee_id ? `${t.from_user_name} → ` : ""}{t.assignee_name}{t.type ? ` · ${TYPE_LABEL[t.type]}` : ""} · s/d {t.deadline || "—"}</span></span>
                    <TaskStatus t={t} />
                </div>
            ))}
        </Card>
    );
}
